import axios from 'axios'

export const HTTP = axios.create({
  // headers: {
  //   'csrf': document.getElementById("csrf").innerText
  // }
});
